import React from "react";
import cookie from 'react-cookies'


class SelectRefresh extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectRefresh:"none"
        } 
    }

    componentDidMount() {
        if(cookie.load('refreshTerm')) {
            this.setState({selectRefresh:cookie.load('refreshTerm')})
        }else{
        this.setState({selectRefresh:"none"})
        }
    }

    setRefreshTerm(e) {
        this.setState({selectRefresh:e.target.value})

        cookie.save('refreshTerm', e.target.value, {path:"/"});
    }

    render() {
        
        return (
             <ul className="setting-box radio-box">
                <li>
                    <label>
                        <input type="radio" value="30" name="refresh" 
                            checked={this.state.selectRefresh==="30"}
                            onChange={(e)=>this.setRefreshTerm(e)}/>
                        <span>30초 마다 갱신</span>
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" value="60" name="refresh"
                            checked={this.state.selectRefresh==="60"}
                            onChange={(e)=>this.setRefreshTerm(e)}/>
                        <span>1분 마다 갱신</span>
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" value="none" name="refresh"
                            checked={this.state.selectRefresh==="none"}
                            onChange={(e)=>this.setRefreshTerm(e)}/>
                        <span>갱신 안함 (기본값)</span>
                    </label>
                </li>
            </ul>
        )
    }
}

export default SelectRefresh;
